import { create } from 'zustand';

// state favoritesModal open / close 
export const useFavoritesModalStore = create((set) => ({
    isOpen: false,
    open: () => {
        set({ isOpen: true });
    },
    close: () => {
        set({ isOpen: false });
    },
    toggleFavoritesModal: () => set((state) => {
        return { isOpen: !state.isOpen };
    }),
}));
